var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 13.75L29.75 13.75C30.1642 13.75 30.5 13.4142 30.5 13V2.5C30.5 2.08579 30.1642 1.75 29.75 1.75L10.25 1.75C9.83579 1.75 9.5 2.08579 9.5 2.5V13C9.5 13.4142 9.83579 13.75 10.25 13.75Z",
    stroke: "#9ED84D",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16H29",
    stroke: "#9ED84D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.25H27.5",
    stroke: "#9ED84D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.5C22.0711 11.5 23.75 9.82107 23.75 7.75C23.75 5.67893 22.0711 4 20 4C17.9289 4 16.25 5.67893 16.25 7.75C16.25 9.82107 17.9289 11.5 20 11.5Z",
    stroke: "#9ED84D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 5.5C29.5054 5.5 28.5516 5.10491 27.8483 4.40165C27.1451 3.69839 26.75 2.74456 26.75 1.75",
    stroke: "#9ED84D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.5C9.99246 5.5 10.4801 5.403 10.9351 5.21455C11.39 5.02609 11.8034 4.74987 12.1517 4.40165C12.4999 4.05343 12.7761 3.64003 12.9645 3.18506C13.153 2.73009 13.25 2.24246 13.25 1.75",
    stroke: "#9ED84D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 10C29.5054 10 28.5516 10.3951 27.8483 11.0983C27.1451 11.8016 26.75 12.7554 26.75 13.75",
    stroke: "#9ED84D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10C9.99246 10 10.4801 10.097 10.9351 10.2855C11.39 10.4739 11.8034 10.7501 12.1517 11.0983C12.4999 11.4466 12.7761 11.86 12.9645 12.3149C13.153 12.7699 13.25 13.2575 13.25 13.75",
    stroke: "#9ED84D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.ae4318df.svg";
export { ForwardRef as ReactComponent };